<div class="card-container">
  <div class="custom-card">
    <div class="icon">
      <mat-icon class="icon-display">task_alt</mat-icon>
    </div>

    <div class="text-big">Successful Payment</div>
    <div class="text-small">
      We will send you the details<br>from the order to your email address<br>after successful payment.
    </div>

    <button mat-raised-button color="primary" (click)="goToDashboard()">Continue to Dashboard</button>

  </div>
</div>
